// import PropTypes from 'prop-types';
import React, { useState, useRef } from 'react';
import InViewObserver from 'components/InViewObserver/InViewObserver';
import s from './AffiliatePageIframe.scss';

const Iframe = () => {
  const [height, setHeight] = useState();
  const [isIframeInView, setIframeInView] = useState(false);
  const iframeRef = useRef(null);

  const onLoad = () => {
    const iframeDocument = iframeRef.current.contentWindow.document;
    setHeight(`${iframeDocument.body.scrollHeight}px`);
    const resizeObserver = new ResizeObserver(entries => {
      const [pageSizeObserver] = entries;
      const { target: { scrollHeight } = {} } = pageSizeObserver || {};
      setHeight(scrollHeight);
    });

    resizeObserver.observe(iframeDocument.body);
  };
  return (
    <div>
      <div className={`${s.separator} clearfix`}>
        <i />
        <span>Up Next</span>
      </div>
      <InViewObserver
        viewMargin="500px 0px 500px 0px"
        inViewCallback={() => {
          setIframeInView(true);
        }}
      >
        {isIframeInView && (
          <iframe
            ref={iframeRef}
            onLoad={onLoad}
            src="/amazon-bestsellers?frmapp=yes&utm_source=perpetual_msp"
            title="amazon-bestsellers"
            id="myFrame"
            width="100%"
            height={height}
            style={{
              width: '100%',
              overflow: 'auto',
              border: 'none',
              minHeight: '400px',
            }}
          />
        )}
      </InViewObserver>
    </div>
  );
};

// Iframe.propTypes = {
//   nextLinks: PropTypes.shape([]),
//   setState: PropTypes.func,
// };

// Iframe.defaultProps = {
//   nextLinks: [],
//   setState: () => {},
// };
export default Iframe;
